import { render, staticRenderFns } from "./WritingEnBox.vue?vue&type=template&id=d2ea1bd0"
import script from "./WritingEnBox.vue?vue&type=script&lang=js"
export * from "./WritingEnBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports